<template>
  <section>
    <div class="lm-local__message-own">
      <div class="lm-local-message-header">
        <p class="lm-local-message-header__source">
          {{ myMessage.messageSource }}
        </p>
        <p>
          <span class="lm-local-message-header__user">
            {{ myMessage.userCode }} - {{ myMessage.userName }}
          </span>
          <span class="lm-local-message-header__date">
            {{ myMessage.createdAt }}
          </span>
        </p>
      </div>
      <div class="lm-local-message-contents">
        {{ myMessage.message }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MessageOwn',
  computed: {
    myMessage () {
      return this.$attrs
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/messages/MessageOwn.vue